import Vue from 'vue'
import moment from 'moment'

export const defaultDaysAmount = 30

const defaultFilters = {
    lastDays: {
        noReset: true,
        type: 'radio',
        text: 'Zakres',
        value: defaultDaysAmount,
        options: [
            {
                label: 'Ostatnie 7 dni',
                value: '7'
            },
            {
                label: 'Ostatnie 30 dni',
                value: '30'
            },
            {
                label: 'Ostatnie 90 dni',
                value: '90'
            }
        ]
    },
    type: {
        type: 'radio',
        text: 'Typ wykresu',
        value: 'AMOUNT',
        noReset: true,
        options: [
            {
                label: 'Kwotowy',
                value: 'AMOUNT'
            },
            {
                label: 'Liczba paragonów',
                value: 'QUANTITY'
            }
        ]
    },
    locationIds: {
        type: 'ui-virtual-list',
        value: null,
        searcher: false,
        label: 'Wybierz sklep',
        getter: 'getDevicesShopsForSelect',
        resetFilter: 'terminalRadIds',
        disabledLinkGenerator: true
    },
    terminalRadIds: {
        type: 'ui-virtual-list',
        value: null,
        searcher: false,
        label: 'Wybierz kasę',
        getter: 'getSaleTrendDevices',
        disabledLinkGenerator: true
    },
    startDate: {
        withTime: true,
        value: moment()
            .subtract(defaultDaysAmount, 'days')
            .format('YYYY-MM-DD HH:mm:ss'),
        type: 'range-date',
        range: 'from',
        text: 'Od',
        title: 'Data',
        groupName: 'range'
    },
    endDate: {
        withTime: true,
        value: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        type: 'range-date',
        range: 'to',
        text: 'Do',
        groupName: 'range'
    }
}

export const saleTrend = {
    state: {
        saleTrend: null,
        status: 'idle',
        groupByOptions: [
            {
                label: 'lokalizacji',
                value: 'SHOP'
            },
            {
                label: 'kasie',
                value: 'TERMINAL'
            }
        ],
        groupBy: 'SHOP',
        filters: { ...defaultFilters }
    },
    mutations: {
        SET_SALETREND(state, payload) {
            state.saleTrend = payload
        },
        SET_SALETREND_STATUS(state, payload) {
            state.status = payload
        },
        SET_SALETREND_FILTER(state, payload) {
            Vue.set(state.filters[payload.filter], 'value', payload.value)
        },
        RESET_SALETREND_FILTERS(state, payload) {
            Vue.set(state, 'filters', payload)
        },
        SET_SALETREND_GROUPBY(state, payload) {
            Vue.set(state, 'groupBy', payload)
        }
    },
    actions: {
        setSaleTrendFilters({ commit, getters }) {
            if (getters.isLotteryUser) {
                const tmpFilters = Object.assign({}, defaultFilters)
                Object.entries(tmpFilters).forEach(entry => {
                    if (entry[0] === 'lastDays') entry[1].value = 7
                    if (entry[0] !== 'type') {
                        entry[1].inactive = true
                    }
                })
                commit('RESET_SALETREND_FILTERS', tmpFilters)
            }
        },
        async saleTrendFetch({ commit, state, getters }) {
            if (state.status === 'idle') {
                commit('SET_SALETREND_STATUS', 'loading')
                const params = {
                    userId: getters.userId,
                    locationIds:
                        state.filters.locationIds &&
                        state.filters.locationIds.value
                            ? [state.filters.locationIds.value]
                            : [],
                    dateFrom: state.filters.startDate.value
                        ? moment(state.filters.startDate.value).format(
                            'YYYY-MM-DD 00:00:00'
                        )
                        : '',
                    dateTo: state.filters.endDate.value
                        ? moment(state.filters.endDate.value).format(
                            'YYYY-MM-DD 23:59:59'
                        )
                        : '',
                    type: state.filters.type.value,
                    dataForAllDevices: true,
                    terminalRadIds: state.filters.terminalRadIds.value
                        ? [state.filters.terminalRadIds.value]
                        : [],
                    groupingType: state.groupBy
                }

                try {
                    let res
                    if (getters.isLotteryUser) {
                        res = await this.$api.get('/lottery/get/sale-trend')
                        if (
                            res.data &&
                            res.data.data &&
                            res.data.data.dataForChart &&
                            res.data.data.dataForChart[0]
                        ) {
                            res.data.data.dataForChart = res.data.data.dataForChart.map(
                                e => {
                                    if (e.data) {
                                        Object.assign(e, { date: e.data })
                                    }
                                    return e
                                }
                            )
                        }
                    } else {
                        res = await this.$api.post(
                            'statistics/saleTrend',
                            params
                        )
                    }
                    commit('SET_SALETREND', res.data.data)
                    commit('SET_SALETREND_STATUS', 'idle')
                } catch (error) {
                    commit('SET_SALETREND_STATUS', 'idle')
                }
            }
        },
        setSaleTrendGroupBy({ commit }, payload) {
            commit('SET_SALETREND_GROUPBY', payload)
        }
    },
    getters: {
        getSaleTrend: state => {
            if (state.saleTrend) {
                return state.saleTrend
            }
        },
        getSaleTrendForChart: state => {
            if (state.saleTrend) {
                const saleTrend = state.saleTrend.dataForChart
                const chartType = state.filters.type.value.toLowerCase()
                const chartData = saleTrend
                    ? saleTrend.map(el => {
                        return (+el[`sum_${chartType}`]).toFixed(2)
                    })
                    : []
                return {
                    chartType: 'line',
                    series: [
                        {
                            name: chartType === 'amount'
                                ? 'Sprzedaż sumaryczna:'
                                : 'Liczba paragonów:',
                            data: chartData
                        }
                    ],
                    yaxis: {
                        title: {
                            text: chartType === 'amount'
                                ? 'Sprzedaż sumaryczna (PLN)'
                                : 'Liczba wystawionych paragonów'
                        }
                    },
                    categories: saleTrend.map(el =>
                        moment(el.date).format('DD-MM-YYYY')
                    ),
                    categoriesTitle: 'Dzień'
                }
            }
        },
        getSaleTrendForFilters: state => {
            if (state.saleTrend) {
                return state.saleTrend.map(item => {
                    return { value: item.id, label: item.name }
                })
            }
        },
        getSaleTrendFilters: state => {
            return state.filters
        },
        getSaleTrendDevices: (state, getters) => {
            if (state.filters.locationIds && state.filters.locationIds.value) {
                const devices = []
                if (getters.getDevices && getters.getDevices.length) {
                    getters.getDevices
                        .find(
                            el =>
                                el.location_id ===
                                state.filters.locationIds.value
                        )
                        .devices.forEach(elem => {
                            devices.push({
                                label: `${elem.unique_number} - ${elem.mcuid}`,
                                value: elem.mcuid
                            })
                        })
                }
                return devices
            }
        },
        getSaleTrendGroupBy: state => {
            return state.groupBy
        },
        getSaleTrendGroupByOptions: state => {
            return state.groupByOptions
        }
    }
}
